import { render, staticRenderFns } from "./Template252.vue?vue&type=template&id=21b151d6"
import script from "./Template252.vue?vue&type=script&lang=js"
export * from "./Template252.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21b151d6')) {
      api.createRecord('21b151d6', component.options)
    } else {
      api.reload('21b151d6', component.options)
    }
    module.hot.accept("./Template252.vue?vue&type=template&id=21b151d6", function () {
      api.rerender('21b151d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Template252.vue"
export default component.exports